import { render, staticRenderFns } from "./publishForm.vue?vue&type=template&id=b818a9ac&scoped=true&"
import script from "./publishForm.vue?vue&type=script&lang=js&"
export * from "./publishForm.vue?vue&type=script&lang=js&"
import style0 from "./publishForm.vue?vue&type=style&index=0&id=b818a9ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b818a9ac",
  null
  
)

export default component.exports